import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Tag } from "lucide-react";
import { getPromoCodes } from "@/services/pricingService";

export const PromoCTA = () => {
  const { data: promoCodes } = useQuery({
    queryKey: ["promo-codes-auto"],
    queryFn: getPromoCodes,
  });

  const hasActivePromos = promoCodes?.some((promo) => {
    const now = new Date();
    const startDate = new Date(promo.start_date);
    const expirationDate = promo.expiration_date ? new Date(promo.expiration_date) : null;
    return (
      promo.public_promo &&
      startDate <= now &&
      (!expirationDate || expirationDate >= now) &&
      (!promo.max_uses || promo.times_used < promo.max_uses)
    );
  });

  if (!hasActivePromos) return null;

  return (
    <section className="bg-villa-offwhite border-y border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-villa-turquoise/10 flex items-center justify-center">
              <Tag className="h-4 w-4 text-villa-turquoise" strokeWidth={1.5} />
            </div>
            <span className="font-medium text-villa-text text-[15px]">
              Des offres spéciales vous attendent !
            </span>
          </div>
          <Link
            to="/promotions"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-villa-turquoise text-white text-sm font-medium rounded-full hover:bg-villa-turquoise/90 transition-all duration-300 hover:-translate-y-px"
          >
            Voir les promotions
          </Link>
        </div>
      </div>
    </section>
  );
};
